import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CustomToastrComponent } from './components/custom-toastr/custom-toastr.component';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { TranslateModule } from '@ngx-translate/core';
import { ModalSuccesfullCustomComponent } from './components/modal-succesfull-custom/modal-succesfull-custom.component';
import { BotonContactoComponent } from './components/boton-contacto/boton-contacto.component';
import { ContactMeModalComponent } from './components/contact-me-modal/contact-me-modal.component';
import { MatDialogModule } from '@angular/material/dialog';
import { BotonLlamarAgenteComponent } from './components/boton-llamar-agente/boton-llamar-agente.component';
import { CallMeNowComponent } from './components/call-me-now/call-me-now.component';
import { CountriesAutocompleteComponent } from './components/countries-autocomplete/countries-autocomplete.component';
import { MatFormFieldModule } from '@angular/material/form-field';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { CurrencyDirective } from '@shared/directives/currency.directive';
import { DragDropDirective } from '@shared/directives/drag-drop.directive';
import { MaxLengthDirective } from '@shared/directives/max-length.directive';
import { OnlyNumberDirective } from '@shared/directives/only-number.directive';
import { PaginationComponent } from './components/pagination/pagination.component';
import { OfertaComponent } from './components/oferta/oferta.component';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatRadioModule } from '@angular/material/radio';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { StarRatingComponent } from './components/star-rating/star-rating.component';
import { RouterModule } from '@angular/router';
import { LoaderComponent } from './components/loader/loader.component';
import { PropertiesPreviewComponent } from '@shared/components/properties-preview/properties-preview.component';
import { CardsHomeComponent } from '@shared/components/cards-home/cards-home.component';
import { ListaLinksEstadisticasComponent } from '@shared/components/lista-links-estadisticas/lista-links-estadisticas.component';
import {
  NgbCarousel,
  NgbModalModule,
  NgbSlide,
} from '@ng-bootstrap/ng-bootstrap';
import { ComparisonMobileComponent } from '@shared/components/comparison-mobile/comparison-mobile.component';
import { BreadcrumbsComponent } from '@shared/components/breadcrumbs/breadcrumbs.component';
import { ModalInvalidComponent } from './components/modal-invalid/modal-invalid.component';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { BlackmonthComponent } from './components/blackmonth/blackmonth.component';
import { RememberToValidateModalComponent } from './components/remember-to-validate-modal/remember-to-validate-modal.component';
import { SpinnerComponent } from './components/spinner/spinner.component';
import { VersionUpdateNotificationComponent } from './components/version-update-notification/version-update-notification.component';
import { GoogleReviewsCommentsComponent } from './components/google-reviews-comments/google-reviews-comments.component';
import { YourPropertyComponent } from './components/your-property/your-property.component';

@NgModule({
  declarations: [
    // DIRECTIVES
    CurrencyDirective,
    DragDropDirective,
    MaxLengthDirective,
    OnlyNumberDirective,
    // COMPONENTS
    CustomToastrComponent,
    ModalSuccesfullCustomComponent,
    CountriesAutocompleteComponent,
    BotonContactoComponent,
    ContactMeModalComponent,
    BotonLlamarAgenteComponent,
    CallMeNowComponent,
    PaginationComponent,
    OfertaComponent,
    LoaderComponent,
    PropertiesPreviewComponent,
    CardsHomeComponent,
    ListaLinksEstadisticasComponent,
    ComparisonMobileComponent,
    BreadcrumbsComponent,
    BreadcrumbsComponent,
    ModalInvalidComponent,
    BlackmonthComponent,
    RememberToValidateModalComponent,
    VersionUpdateNotificationComponent,
  ],
  imports: [
    CommonModule,
    MatIconModule,
    MatButtonModule,
    MatSnackBarModule,
    TranslateModule,
    ReactiveFormsModule,
    MatAutocompleteModule,
    MatDialogModule,
    MatFormFieldModule,
    FormsModule,
    MatProgressSpinnerModule,
    MatRadioModule,
    MatProgressBarModule,
    RouterModule,
    NgbCarousel,
    NgbSlide,
    NgbModalModule,
    MatCheckboxModule,
    YourPropertyComponent,
    GoogleReviewsCommentsComponent,
    SpinnerComponent,
    StarRatingComponent,
  ],
  exports: [
    CountriesAutocompleteComponent,
    BotonContactoComponent,
    BotonLlamarAgenteComponent,
    CallMeNowComponent,
    PaginationComponent,
    LoaderComponent,
    PropertiesPreviewComponent,
    ListaLinksEstadisticasComponent,
    ComparisonMobileComponent,
    BreadcrumbsComponent,
    BlackmonthComponent,
    RememberToValidateModalComponent,
    VersionUpdateNotificationComponent,
    GoogleReviewsCommentsComponent,
    YourPropertyComponent,
    CardsHomeComponent,
    SpinnerComponent,
    StarRatingComponent,
    // DIRECTIVES
    CurrencyDirective,
    DragDropDirective,
    MaxLengthDirective,
    OnlyNumberDirective,
    BreadcrumbsComponent,
  ],
})
export class SharedModule {}
